import React, { FC } from 'react';
import ClickAwayListener from 'react-click-away-listener';

import { useHandleClickAway } from '../../Hooks/useHandleClickAway';
import classNames from 'classnames';
import { CloseButton } from '../../../Booking/CloseButton/CloseButton';
import { CloseButton as LegacyCloseButton } from '../../../BookingLegacy/CloseButton/CloseButton';

type PopUpContainerProps = {
  isOpen: boolean;
  handleCloseButtonClick: (value: boolean) => void;
  Modal: any;
  modalOpenedClassName?: string;
  closeButtonLabel?: string;
  isNewBooking?: boolean;
}

export const PopUpContainer: FC<PopUpContainerProps> = ({
  isOpen,
  Modal,
  handleCloseButtonClick,
  children,
  modalOpenedClassName,
  isNewBooking
}) => {
  const {
    handleMouseUp,
    handleMouseDown,
    handleClickAway,
    areaRef,
  } = useHandleClickAway(handleModalClose);

  function handleModalClose() {
    handleCloseButtonClick(false)
  }

  return (
    <Modal
      bodyOpenClassName={modalOpenedClassName ?? "ReactModal__Body--open"}
      overlayClassName="react-modal__overlay"
      className={classNames("react-modal__content react-modal__content--additional", {
        'react-modal__content--opened': isOpen,
        'new-booking': isNewBooking,
      })}
      isOpen={isOpen}
      shouldCloseOnEsc
      onRequestClose={handleModalClose}
    >
      <div className="confirm-modal__outer">
        <ClickAwayListener onClickAway={handleClickAway}>
          <div className="confirm-modal__inner my-2 p-2 pt-1 fs-5" ref={areaRef} onMouseDown={handleMouseDown} onMouseUp={handleMouseUp}>
            {isNewBooking && <CloseButton onClick={handleModalClose} />}
            {!isNewBooking && <LegacyCloseButton onClick={handleModalClose} />}
            {children}
          </div>
        </ClickAwayListener>
      </div>
    </Modal>
  )
};
